/** @format */

import React, { useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { PageContainer, ButtonLoading, InputV2, SelectV, Icons , InputCurrency } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import { useStyles } from './Style';
import { useNavigate } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import Services from '../../services/ServicesNewWIthdrawRule';
import WITHDRAW_TYPES from '../../constants/ruleTypes';
import createToast from 'components/Toast/Toast';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const CreateDiscount = () => {
  // -- STATE --//
  const [loading, setLoading] = useState(false);
  const actionsList = getDynamicObjectAction([
    'createWithdrawRulesPage',
    'contentsWithdrawRulesPage',
  ]);
  // -- HOOKS --//
  const navigate = useNavigate();

  const methods = useForm();
  const { handleSubmit, formState: { errors }, reset, watch, setValue } = methods;
  const classes = useStyles();

  useEffect(() => {
    setValue('typeCode', WITHDRAW_TYPES[0].value);
  }, []);

  // -- API REQUESTS --//
  async function postForm(data) {
    try {
      const body = checkForm(data);
      if (!body) return;

      setLoading(true);

      ['typeCode', 'subscriptionDays', 'maxAmount', 'maxCount'].forEach((v) => {
        if (!body.hasOwnProperty(v)) body[v] = null;
      });

      await Services.postRule(data);
      setLoading(false);
      createToast('موفق', 'قانون برداشت با موفقیت ایجاد شد!', 'success');

      scroll.scrollToTop();
      reset({
        typeCode: WITHDRAW_TYPES[0].value,
        subscriptionDays: '',
        maxAmount: '',
        maxCount: '',
      });
      navigate('/WithdrawRules/RulesList');
    } catch (e) {
      setLoading(false);
    }
  }

  const checkForm = (body) => {
    const bodyCp = { ...body };
    const targetType = isAvailable();
    const checksArray = [
      { dataKey: 'subscriptionDays', limitKey: 'daysLimit', title: 'مدت اشتراک' },
      {
        dataKey: 'maxAmount',
        limitKey: 'amountLimit',
        title: 'سقف مبلغ قابل برداشت',
      },
      {
        dataKey: 'maxCount',
        limitKey: 'countLimit',
        title: 'حداکثر دفعات قابل برداشت',
      },
    ];

    for (const v in checksArray) {
      if (!targetType?.[v.limitKey]) delete bodyCp?.[v.dataKey];
      else if (bodyCp?.[v.dataKey] || bodyCp?.[v.dataKey]?.length === 0) {
        return null;
      }
    }

    return bodyCp;
  };
  const hint =
    'شما در این قسمت می‌توانید قانون جدیدی برای برداشت از حساب دیجیتال مشتریان خود تعریف کنید.';

  const isAvailable = () => {
    const newType = watch('typeCode');
    return WITHDRAW_TYPES.find((v) => v.value === newType) ?? null;
  };

  return (
    <PageContainer
      subTitle={hint}
      title="قانون برداشت جدید"
      meta={
        actionsList['contentsWithdrawRulesPage'] && (
          <Button
            color="primary"
            variant="outlined"
            endIcon={<Icons icon="CaretLeft" color="#2b3990" size="25" />}
            onClick={() => navigate('/WithdrawRules/RulesList')}
          >
            بازگشت به لیست قوانین
          </Button>
        )
      }
      breadcrumbs={constBreadCrumbsTitle.WITHDRAWRULES_NEW_RULE}
    >
      {actionsList['createWithdrawRulesPage'] && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(postForm)}>
            <Grid container className={classes.formFields}>
              <Grid item xs={12} md={4}>
                <SelectV
                  name="typeCode"
                  options={WITHDRAW_TYPES}
                  label="نوع مجوز"
                  control={methods.control}
                  register={methods.register}
                  rules={['required']}
                  required
                  defaultValue={WITHDRAW_TYPES[0].value}
                  errors={methods.formState.errors}
                  fullWidth
                />
              </Grid>
              {isAvailable()?.daysLimit ? (
                <Grid item xs={12} md={2}>
                  <InputV2
                    fullWidth
                    label="طول مدت اشتراک"
                    errors={methods.formState.errors}
                    name="subscriptionDays"
                    register={methods.register}
                    currencyText="روز"
                    rules={['required', 'isNumeric', 'isMin|1']}
                    control={methods.control}
                    minimumValue={0}
                    decimalPlaces={0}
                    currency
                    englishNumber
                  />
                </Grid>
              ) : null}
            {isAvailable()?.amountLimit ? (
              <Grid item xs={12} md={2}>
                <InputCurrency
                  fullWidth
                  label="سقف مبلغ قابل برداشت"
                  errors={methods.formState.errors}
                  name="maxAmount"
                  register={methods.register}
                  rules={['required', 'isNumeric', 'isMin|1']}
                  control={methods.control}
                  minimumValue={0}
                  decimalPlaces={0}
                  englishNumber
                />
              </Grid>
            ) : null}
              {isAvailable()?.countLimit ? (
              <Grid item xs={12} md={2}>
                <InputV2
                  fullWidth
                  label="حداکثر تعداد دفعات برداشت"
                  errors={methods.formState.errors}
                  name="maxCount"
                  register={methods.register}
                  currencyText="مرتبه"
                  rules={['required', 'isNumeric', 'isMin|1']}
                  control={methods.control}
                  minimumValue={0}
                  decimalPlaces={0}
                  currency
                  englishNumber
                />
              </Grid>
              ) : null}
            </Grid>

            <Grid container item xs={12} justifyContent="flex-start">
              <div className={classes.containButton}>
                <ButtonLoading
                  variant="contained"
                  color="primary"
                  loading={loading}
                  name="تایید"
                  type="submit"
                />
              </div>
            </Grid>
          </form>
        </FormProvider>
      )}
    </PageContainer>
  );
};

export default CreateDiscount;
